import { useQuery, useQueryClient } from '@tanstack/react-query'
import { fetchPresales } from '@/lib/subgraph'
import { Presale } from '@/types'

export function usePresales() {
  const queryClient = useQueryClient()
  
  const query = useQuery<Presale[]>({
    queryKey: ['presales'],
    queryFn: fetchPresales,
    staleTime: 60000, // 60 seconds
    refetchInterval: false, // Disable auto-refetch to avoid rate limiting
  })

  const refetch = () => {
    queryClient.invalidateQueries({ queryKey: ['presales'] })
    queryClient.invalidateQueries({ queryKey: ['pendingPresales'] })
    return query.refetch()
  }

  return {
    ...query,
    refetch
  }
}

